import styles from '../../css/wheater.module.css'

const Form = ({onSelectName, change, text, click})=>{

  return(
    <form 
      className={`${styles.weatherForm} userSelectNone`}
      onSubmit={(e)=>{
            e.preventDefault()
            onSelectName(text.trim())   
            click()
          }
    }>
      <input type="text" onChange={change} value={text}  placeholder="miejscowość lub szczyt" />
      <button >Wyszukaj</button>   
    </form>
  )

}

export default Form